import axios, { AxiosResponse } from "axios";
import { SFAccount } from "../lib/models/sf-account.model";
import { SFDeal } from "../lib/models/sf-deal.model";
import { SFUserProfile } from "../lib/models/sf-user-profile.model";
import { ApiUtils } from "./ApiUtils";

export class SalesforceApi {
  private static readonly _baseUrl = ApiUtils.getBaseSalesforceApiUrl();

  private static readonly _baseSearchUrl =
    ApiUtils.getBaseSalesforceSearchApiUrl();

  public static getUserProfile(
    email: string
  ): Promise<AxiosResponse<SFUserProfile>> {
    return axios.get<SFUserProfile>(
      `${this._baseUrl}/userProfile?email=${email.toLowerCase()}`
    );
  }

  public static getAccounts(
    email: string
  ): Promise<AxiosResponse<SFAccount[]>> {
    return axios.get<SFAccount[]>(
      `${this._baseSearchUrl}/accounts?username=${email.toLowerCase()}`
    );
  }

  public static getDeals(accountId: number): Promise<AxiosResponse<SFDeal[]>> {
    return axios.get<SFDeal[]>(
      `${this._baseSearchUrl}/deals?accountid=${accountId}`
    );
  }

  public static getAccountById(
    accountId: string
  ): Promise<AxiosResponse<SFAccount>> {
    return axios.get<SFAccount>(`${this._baseSearchUrl}/accounts/${accountId}`);
  }

  public static getAccountsByQuery(
    query: string
  ): Promise<AxiosResponse<SFAccount[]>> {
    return axios.get<SFAccount[]>(
      `${this._baseSearchUrl}/search?type=account&query=${encodeURIComponent(
        query
      )}`
    );
  }
}
